import { render } from "./startExam.vue?vue&type=template&id=430e9f0e&scoped=true"
import script from "./startExam.vue?vue&type=script&lang=js"
export * from "./startExam.vue?vue&type=script&lang=js"

import "./startExam.vue?vue&type=style&index=0&id=430e9f0e&lang=scss&scoped=true"
import "./startExam.vue?vue&type=style&index=1&id=430e9f0e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430e9f0e"]])

export default __exports__